import ValidatedFormView from '../form/ValidatedFormView';
import {ValidatedAddressMixin} from '../form/ValidatedAddressMixin';
// import '../form/FormControlHelp';

const FORM_PREFIX = 'tx_project_formcontact[formContactFormData]';

export class FormContact extends ValidatedFormView {
  constructor(options) {
    super( Object.assign({
      formName: 'formContactFormData',
      validations: {
        [`${FORM_PREFIX}[firstName]`]: ['required', 'forename'],
        [`${FORM_PREFIX}[lastName]`]: ['required', 'lastname'],
        [`${FORM_PREFIX}[street]`]: ['required', {'func': 'address1Rule'}],
        [`${FORM_PREFIX}[addressAddition]`]: ['optional'],
        [`${FORM_PREFIX}[zip]`]: ['required', {'func': 'zipRule'}],
        [`${FORM_PREFIX}[city]`]: ['required', 'city'],
        [`${FORM_PREFIX}[phone]`]: ['optional', 'phone'],
        [`${FORM_PREFIX}[email]`]: ['required', 'email'],
        [`${FORM_PREFIX}[message]`]: ['required'],
      },
    }, options, ValidatedAddressMixin));

    this.scrollToErrorMessage();
  }
}
